<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
      <tr>
        <th v-for="header in headers" :key="header.COMP_ID">{{ header.COMP_NAME }}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td> Верхний предел, %</td>
        <td v-for="cell in components" :key="cell.COMP_ID">
          {{ numLocaleDecorator(cell.COMP_UPPER_LIMIT) }}
        </td>
      </tr>
      <tr>
        <td> Нижний предел, %</td>
        <td v-for="cell in components" :key="cell.COMP_ID">
          {{ numLocaleDecorator(cell.COMP_LOWER_LIMIT) }}
        </td>
      </tr>
      <tr>
        <td> Шаг, %</td>
        <td v-for="cell in components" :key="cell.COMP_ID">
          {{ numLocaleDecorator(cell.COMP_STEP) }}
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { numDecorator } from '@/components/modules/projects/mixins/numDecorator'
export default {
  name: 'tblCalculationCompConcLimits',
  components: {},
  mixins: [numDecorator],
  props: {
    components: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    headers: {
      get () {
        const ret = this.components
        return [{ COMP_NAME: '', COMP_ID: '-1' }, ...ret]
      }
    }
  },
  watch: {},
  methods: {},
  mounted () {
    console.log('tblCalculationCompConcLimits mounted with comps ', this.components)
  }
}
</script>

<style scoped>

</style>
